import {IHttpProvider, IHttpResponse, IQService, IScope} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";


const enum ResponsStatus {OK = 200, UNAUTHORIZED = 401}

export const httpUnauthorizedEvent = "httpProvider:unathorized";
export const stateManglendeTilgangsnivåEvent = "stateChange:manglendeTilgangsnivå";

/** $httpProvider interceptor som broadcaster en
 * httpUnauthorizedEvent event på rootScope ved 401 feil */
function responseErrorInterceptor($q: IQService, $rootScope: IScope) {
    return {
        responseError: (rejection: IHttpResponse<any>) => {
            if (rejection.status == ResponsStatus.UNAUTHORIZED)
                $rootScope.$broadcast(httpUnauthorizedEvent, rejection);
            return $q.reject(rejection);
        }
    }
}

export function registrerRequestAutentiseringsInterceptorForInjisering() {
    return [
        regNavn.ng.$httpProvider,
        ($httpProvider: IHttpProvider) =>
            $httpProvider.interceptors.push([regNavn.ng.$q, regNavn.ng.$rootScope, responseErrorInterceptor])
    ];
}
